<template>
    <search-group  :span="24" :inline="true" :btnSpan="4" :btnOffset="20" :multipleLines="true"   @search="findData" @clear="clearValue" >
        <Row class="mb16" :gutter="16">
            <Col span="4">
              <Select v-model="searchData.projectFid" placeholder="请选择项目" @on-change="changeProject">
                <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.spaceid" placeholder="空间">
                <Option value=''>请选择</Option>
                <Option v-for="item in areaList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.categoryCode" placeholder="大类" @on-change="changeCategoryCode">
                <Option value=''>请选择</Option>
                <Option v-for="item in categoryList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.goodsCode" placeholder="物品">
                <Option value=''>{{searchData.categoryCode==='' ? '请先选择大类':(goodsList.length===0?'暂无数据':'请选择')}}</Option>
                <Option v-for="item in goodsList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.businessSource" placeholder="来源">
                <Option value=''>请选择</Option>
                <Option v-for="item in sourceList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.orderStatus" placeholder="状态">
                <Option value=''>请选择</Option>
                <Option v-for="item in stateList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
        </Row>
        <Row :gutter="16">
          <Col span="6">
            <DatePicker v-model="createTime" split-panels type="daterange" format="yyyy-MM-dd" @on-change="changeCreateTime" placeholder="创建时间"></DatePicker>
          </Col>
          <Col span="6">
            <DatePicker v-model="visitTime" split-panels type="daterange" format="yyyy-MM-dd" @on-change="changeVisitTime" placeholder="上门时间"></DatePicker>
          </Col>
          <Col span="8">
            <Input type="text" v-model="searchData.keyWords" placeholder="报修人信息、联系人信息、房间号、功能区" @keyup.enter.native="findData"></Input>
          </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">
// import SearchGroup from 'components/SearchGroup/index';
export default {
  props:{
    projectList:{
      type:Array,
      default: () => {
        return []
      }
    },
    areaList:{
      type:Array,
      default: () => {
        return []
      }
    },
    categoryList:{
      type:Array,
      default: () => {
        return []
      }
    },
    stateList:{
      type:Array,
      default: () => {
        return []
      }
    },
    sourceList:{
      type:Array,
      default: () => {
        return []
      }
    }
  },
  created(){
    // this.findData()
  },
  watch: {
    projectList(val){
      // console.log(val)
      this.searchData.projectFid = val[0].value
      // this.findData()
    }

  },
  components: {
    // SearchGroup
  },
  data () {
    return {
      searchData:{
        projectFid:'',
        spaceid:'',
        categoryCode:'',
        goodsCode:'',
        businessSource:13, // 默认自如寓
        orderStatus:'',
        createTimeEnd:'',
        createTimeStart:'',
        visitTimeStart:'',
        visitTimeEnd:'',
        keyWords:'',
        limit: 10,
        page: 1
      },
      goodsList:[],
      createTime:[],
      visitTime:[]
    }
  },
  methods: {
      changeProject() {
          this.$emit('changeProject',this.searchData.projectFid)
      },
    changeCategoryCode(val){
      // console.log(val)
      if(!val){
        this.goodsList = []
      } else{
        for (let [index, item] of this.categoryList.entries()) {
        if (val === item.value) {
            this.goodsList = this.categoryList[index].children;
        }
      }
      }
    },
    changeCreateTime(val){
      this.searchData.createTimeStart = val[0]
      this.searchData.createTimeEnd = val[1]
    },
    changeVisitTime(val){
      this.searchData.visitTimeStart = val[0]
      this.searchData.visitTimeEnd = val[1]
    },
    findData() {
      this.$emit('findData',this.searchData)
    },
    clearValue() {
      this.searchData.page = 1
      for (let key in this.searchData){
        if(key ==='page' || key === 'limit' || key === 'projectFid' ) continue
        this.searchData[key] = ''
      }
      this.createTime=[]
    }
  }
}
</script>
<style scoped>
.dash {
    text-align: center;
  }
.dash span {
  display: inline-block;
  width: 60%;
  height: 2px;
  background: #dddee1;
  vertical-align: middle;
}

.ivu-date-picker {
  width: 100%;
}
</style>

